import {ISettingTypeState} from 'src/app/modules/siteSettings/components/settings'
import {toAbsoluteUrl} from '../../../helpers'
import {settingAssetUrl} from 'src/app/queries/signedMediaUrl'
import {useSelector} from 'react-redux'
import {useEffect, useState} from 'react'
import {isEmpty} from 'lodash'
export function FallbackView() {
  const [logo, setLogo] = useState('')
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Theme settings']?.map((item: any) => {
          if (item?.name === 'mainLogo') {
            setLogo(settingAssetUrl(item))
          }
        })
    }
  }, [settingTypeData])

  return (
    <div className='splash-screen'>
      <img src={logo || `/media/logos/bank-log.png`} alt='Start logo' />
      {/* <span>Loading ...</span> */}
    </div>
  )
}
